import React, { Component } from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { ROUTES, ROOT_PATHS } from '../routes';

export class SwitchRoutes extends Component {
  getRootPath() {
    return this.props.isAuthenticated ? ROOT_PATHS.protected : ROOT_PATHS.public;
  }

  shouldRedirectRoute(route) {
    return (
      route.protectedOnly && !this.props.isAuthenticated
    ) || (
      route.publicOnly && this.props.isAuthenticated
    );
  }

  render() {
    if (!this.props.isLoading) {
      return (<div />);
    }

    const rootPath = this.getRootPath();

    return (
      <Switch>
        {ROUTES.map((route, index) => (this.shouldRedirectRoute(route)
          ? (
            <Redirect
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              from={route.path}
              to={rootPath}
              exact
            />
          ) : (
            <Route
              // eslint-disable-next-line react/no-array-index-key
              key={index}
              path={route.path}
              component={route.component}
              exact={route.exact}
            />
          )
        ))}
      </Switch>
    );
  }
}

SwitchRoutes.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool,
};

SwitchRoutes.defaultProps = {
  isAuthenticated: false,
};

const mapStateToProps = mapStore => ({
  isLoading: mapStore.authState.isFetched,
  isAuthenticated: mapStore.authState.isAuthenticated,
});

const SwitchAuthRoutes = withRouter(connect(mapStateToProps)(SwitchRoutes));

export default SwitchAuthRoutes;



// WEBPACK FOOTER //
// ./src/App/SwitchRoutes.js